import React from "react";
import { TableColumn } from "./constants";
import { getCellClass } from "./constants";

interface TableRowProps {
  row: any;
  columns: TableColumn[];
  rowIndex: number;
  actions?: (row: any) => React.ReactNode;
}

// Memoized row component - only re-renders when props actually change
const TableRow: React.FC<TableRowProps> = React.memo(
  ({ row, columns, rowIndex, actions }) => {
    return (
      <tr key={rowIndex} className="hover:bg-gray-50 ">
        {/* Map through columns for each row */}
        {columns.map((column) => (
          <td
            key={`${rowIndex}-${column.key}`}
            className={getCellClass(column.align)}
          >
            {column.render
              ? column.render(row[column.key], row)
              : row[column.key]}
          </td>
        ))}

        {/* Actions cell */}
        {actions && (
          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-2">
            {actions(row)}
          </td>
        )}
      </tr>
    );
  }
);

TableRow.displayName = "TableRow";

export default TableRow;
